import clsx from 'clsx'

// Real ARGO logo — bold navy wordmark with the green leaf on the O.
// Rendered inline so the letters inherit `currentColor` (brand navy on light
// surfaces, white on the navy sidebar / dark landing) while the leaf stays
// green. The A and R counters are true holes (fill-rule="evenodd"), so they
// show whatever background sits behind them. Artwork bbox → viewBox below.
const PATH = {
  A: 'M174.09,352.8l-62.63.11-13.32,36.41-47.56-.05,11.27-29.73,54.04-135.9,56.88.02,45.83,112.59,20.96,53.03h-51.79s-13.68-36.47-13.68-36.47ZM163.37,321.58l-21.07-55.32-20.75,55.42,41.82-.11Z',
  R: 'M406.11,346.96c2.62,15.71,7.88,29.4,18.6,42.26l-55.5.08c-10.09-16.55-6.29-38.46-17.79-50.17-6.02-4.88-13.39-7.23-21.26-7.26l-32.85-.13v57.5s-47.73.05-47.73.05v-165.66s91.54.24,91.54.24c12.87.03,25.41,2.91,37.11,7.61,10.63,4.8,20.1,11.68,24.76,22.34,3.54,8.09,4.76,16.73,3.16,25.08-3.74,19.55-15.22,28.73-33.99,35.44,18.41,4.32,30.69,13.08,33.95,32.62ZM351.11,294.96c9.37-7.25,11.46-20.76,5.02-30.35-5.21-5.9-12.33-7.48-20.04-8.46l-38.78-.18-.02,43.47,37.4-.04c5.89,0,11.23-1.57,16.42-4.44Z',
  G: 'M518.47,327.52l-.02-29.88h84.2s0,91.59,0,91.59l-37.45.03-3.72-21.58c-9.17,12.71-21.06,21.22-36.75,23.76-22.22,3.6-46.54-1.25-65.75-13.19-22-13.68-34.26-37.58-35.61-62.88l.04-14.4c1.37-27.42,15.91-51.76,39.78-65.87,17.04-10.07,36.76-14,56.74-13.69,38.18.6,77.28,15.13,81.02,57.97l-46.72.04c-2.42-9.89-9.91-17.4-19.68-20.67-11.83-3.75-24.84-3.48-36.2,1.35-24.98,10.87-31.06,40.84-24.44,65.13,4.69,17.2,18.32,29.15,35.89,31.65,22.34,3.18,44.31-4.93,47.68-29.31l-39-.05Z',
  O: 'M794.97,271.21c8.6,19.93,8.63,44.44,2.6,65.23-7.65,26.34-27.46,45.42-53.95,52.47-20.25,5.38-42.24,5.18-62.53-.37-45.96-12.58-69.75-58.7-57.67-103.69,6.53-24.3,23-43.98,46.16-53.87s52.5-11.18,76.74-1.52c-7.21,10.24-11.79,21.03-10.93,33.25-12.98-7.91-28.89-8.34-42.73-1.54-21.4,10.51-27.15,37.27-23,59.31,4.23,22.48,22.19,37.95,45.23,36.93,16.02-.71,29.86-10.07,36.24-25.35,5.11-12.26,6.14-26.29,3.64-39.12,16.43-.55,31.43-7.29,40.22-21.73Z',
  LEAF: 'M769.7,252.89c-6.25,11.19-10.8,22.42-18.12,32.4-16.2-19.87-10.05-42.22,6.63-59.85,6.77-7.15,13.65-13.61,18.57-22.98,15.45,19.2,25.88,43.84,12.05,65.94-7.88,12.59-21.88,19.03-36.27,18.85,7.48-10.39,14.86-21.13,17.15-34.36Z',
}

const RATIO = 751.2 / 190.4

export function Wordmark({ size = 26, glow: _glow = true, className }: { size?: number; glow?: boolean; className?: string }) {
  return (
    <svg
      className={clsx('wordmark', className)}
      role="img"
      aria-label="ARGO"
      viewBox="50.6 202.5 751.2 190.4"
      height={size}
      width={+(size * RATIO).toFixed(2)}
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
    >
      <g fill="currentColor">
        <path d={PATH.A} fillRule="evenodd" />
        <path d={PATH.R} fillRule="evenodd" />
        <path d={PATH.G} />
        <path d={PATH.O} />
      </g>
      <path d={PATH.LEAF} fill="#689254" />
    </svg>
  )
}
